import { GEOSERVER_URL } from './env';
import { getLayerState } from './etl-monitor'

// ESRI
import TimeExtent from '@arcgis/core/TimeExtent'

export var tx7Days, tx7Days1Hours;

export var layers = {}
export var layerResultsCache = {};
export var is_updating = false;

export var timeBetweenStatusChecks = 60 * 2 * 1000 // every 2 minutes
export var lastTimeStatusWasChecked = 0

export var rfs_spatial_url = "https://spatial.rfs.nsw.gov.au/ags/rest/services/";

export var currentLayerObj;

export function setCurrentLayerObj(layerObj) {
    currentLayerObj = layerObj;
}

export function addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(date.getHours() + hours));
}

export function sleep(ms){
    return new Promise (resolve => setTimeout(resolve,ms));
}

export function getThumbPosition(timeExtent) {
    let lastValueReported = timeExtent.target._slider._lastValueReported;
    let numberOfSliderStops = timeExtent.target._numStops - 1;

    //calculates the percentage of the slider that is filled, finds the equivalent number of stops, then rounds it so we can return an integer
    return Math.round((lastValueReported/100) * numberOfSliderStops);
}

function quantizeTo12AM(queryTime) {
    let quantizedQueryTime = new Date(queryTime).setHours(0,0,0,0);
    return new Date(quantizedQueryTime);
}

function quantizeToNearestHour(queryTime) {
    queryTime.setHours(queryTime.getHours() + Math.round(queryTime.getMinutes()/60));
    queryTime.setMinutes(0,0,0);
    return queryTime;
}

//finds the value in rawResults with the closest timestep to time
function findNearestTime(rawResults, time) {
    const formattedDateTime = new Date(time);

    let sortedRawResults = rawResults.features.sort((a, b) => {
        const timeA = new Date(a.properties.timestep);
        const timeB = new Date(b.properties.timestep);
        return Math.abs(formattedDateTime - timeA) - Math.abs(formattedDateTime - timeB);
    })
    
    return sortedRawResults;
}

//finds the earliest time in rawResults
function findEarliestTime(rawResults) {
    let sortedRawResults = rawResults.features.sort((a, b) => {
        const timeA = new Date(a.properties.timestep);
        const timeB = new Date(b.properties.timestep);
        return Math.abs(timeA) - Math.abs(timeB);
    })

    return sortedRawResults[0];
}

export function callGPTask(gp, params, callback, errorCallback) {
    // Deprecated: GP Task not used anymore
    // Set the error callback if not provided
    if (errorCallback === undefined) {
        function errorCb(err) {
            console.log(err);
        }
        errorCallback = errorCb;
    }

    function statusCallback(jobInfo) {
        console.log(jobInfo.jobStatus);
    }

    function jobComplete(results, messages) {
        gp.getResultData(results.jobId, "Result", callback, errorCallback);
    }

    gp.submitJob(params, jobComplete, statusCallback);
}

export function checkInvalidateCache(layer_name, callback, onerror) {
    if (Date.now() < lastTimeStatusWasChecked + timeBetweenStatusChecks) {
        callback()
    } else {
        lastTimeStatusWasChecked = Date.now();
        is_updating = false;
        callback();
        // getLayerState(layers[layer_name], function(status) {
        //     for (var key in status) {
        //         if (status[key] == "PENDING") {
        //             layers[layer_name].status = "PENDING"
        //             break;
        //         } else if (status[key] == "PROCESSING") {
        //             layers[layer_name].status = "PROCESSING"
        //             break;
        //         } else {
        //             layers[layer_name].status = "OKAY"
        //         }
        //     }
        //     if (layers[layer_name].status == "PENDING" || layers[layer_name].status == "PROCESSING") {
        //         is_updating = true
        //         layerResultsCache = {}
        //     } else {
        //         is_updating = false
        //     }
        //     callback()
        // }, onerror)
    }
}

export function getLayerAttributesToClosestTime(layer_name, queryTime, callback, onerror) {
    // leaving queryTime as null or an empty string will return everything


    // this is probably not the best way of doing this
    // feel free to rewrite
    const layer = layers[layer_name];

    if(layer.schedule == "Daily") {
        queryTime = quantizeTo12AM(queryTime);
    }

    
    function handleResults(raw_results) {
        var layerCacheResults = layerResultsCache[layer_name];

        if (!layerCacheResults) {
            layerCacheResults = {};
        }

        const results = raw_results.features.flatMap((layer) => layer.attributes);
        layerCacheResults['' + queryTime.getTime()] = results[0];

        if (!is_updating) {
            // only update the cache if it is safe to do so
            layerResultsCache[layer_name] = layerCacheResults;
        }

        if (results.length == 1) {
            callback(layerCacheResults['' + queryTime.getTime()] );
        } else {
            callback(layerCacheResults);
        }
    }

    async function returnCache() {
        if(queryTime){
            callback(layerResultsCache[layer_name]['' + queryTime.getTime()]);
        }
        else {
            callback(layerResultsCache[layer_name]);
        }
    }
    
    checkInvalidateCache(layer_name, function() {
        if (layerResultsCache[layer_name] === undefined ||
            _.isEmpty(layerResultsCache[layer_name]) ||
           (queryTime && layerResultsCache[layer_name]['' + queryTime.getTime()] === undefined)) {
            if (layer.lyrType === 'Forecast_WMS') {
                const params = new URLSearchParams({
                    'SERVICE': 'WMS',
                    'VERSION': '1.1.1',
                    'REQUEST': 'GetFeatureInfo',
                    'FORMAT': 'image/png',
                    'TRANSPARENT': 'true',
                    'QUERY_LAYERS': `${layer.geoserverId}_boundary`,
                    'LAYERS': `${layer.geoserverId}_boundary`,
                    'INFO_FORMAT': 'application/json',
                    'FEATURE_COUNT': '',
                    'exceptions': 'application/json',
                    'FEATURE_COUNT': '500',
                    'X': '50',
                    'Y': '50',
                    'SRS': 'EPSG:4326',
                    'WIDTH': '101',
                    'HEIGHT': '101',
                    'BBOX': '73.828125,-97.734375,215.859375,44.296875'
                });

                let queryAsDate = new Date(queryTime);
                let searchTimeDayEarlier = addHoursToDate(queryAsDate, -24).toISOString();

                //Soil Moisture Index has a unique forecast schedule
                if (layer_name == "SMI_SFC") {
                    queryAsDate = addHoursToDate(queryAsDate, -72);
                    searchTimeDayEarlier = addHoursToDate(queryAsDate,-24).toISOString();
                    queryAsDate = queryAsDate.toISOString();
                }

                params.append('cql_filter', `timestep >= ${searchTimeDayEarlier}`);

                $.getJSON(`${layer.url}?${params.toString()}`).then((rawResponse) => {
                    const nearestLayer = findNearestTime(rawResponse, queryAsDate)[0];
                    const results = { ...rawResponse, features: [nearestLayer], numberReturned: 1 };
                    
                    if (nearestLayer == undefined) {
                        callback("No layer data found");
                    }
                    else {
                        const earliestAvailableForecast = new Date((findEarliestTime(rawResponse).properties.timestep));
                        if (queryTime < earliestAvailableForecast && layer.schedule == "Hourly") {
                            const tooEarlyReturnObject = {tooEarly: true, returnMessage: "No data found. Earliest forecast: ", forecast_datetime: new Date(nearestLayer.properties.timestep)};
                            callback(tooEarlyReturnObject);
                        }
                        else {
                            handleResults({
                                ...results,
                                features: results.features.map(({ properties, id }) => ({
                                    attributes: {
                                        ...properties,
                                        name: id,
                                        hasdata: true,
                                        forecast_datetime: new Date(properties.timestep),
                                        process_datetime: new Date(properties.issue_time).getTime(),
                                        status: 'SUCCESS', // Temp value
                                        raster_hash: properties.location.split('/').splice(-1)[0].split('.')[0]
                                    }
                                }))
                            })
                        }
                    }
                })
            } else {
                __non_webpack_require__([
                    "esri/tasks/QueryTask",
                    "esri/tasks/query",
                ], function (
                    QueryTask, Query
                ) {
                    var queryTask = new QueryTask(layer.qryUrl);
                    var query = new Query();
                    query.returnGeometry = false;
                    query.outFields = ['name', 'step', 'hasdata', 'forecast_datetime',
                        'process_datetime', 'status', 'raster_hash'
                    ];

                    if (!step) {
                        query.where = "1=1";
                    } else {
                        query.where = "step = '" + step + "'"; //This seems to still be using the old method, but I'm not sure under what conditions it ever gets called
                    }

                    queryTask.execute(query, handleResults, onerror);
                });
            }
        }
        else {
            // Need to call the async function so the callback is always handled async
            returnCache();
        }
    }, onerror)

}

function makeGetRequest(url) {
    return new Promise((resolve, reject) => {
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not OK');
            }
            return response.blob(); // Retrieve the response as a blob
          })
          .then(blob => {
            resolve(URL.createObjectURL(blob)); // Convert the blob to a URL
          })
          .catch(error => {
            reject(error);
          });
      });
  }



export function loadLegendHTML(layer, callback) {
    var legendUrl = layer.url + '/legend?f=pjson';
    if (layer.legendUrl) {
        legendUrl = layer.legendUrl
    }


    if (layer.legend == "legendNone") {
        callback(``)
    }
    if (layer.lyrType === 'Forecast_WMS') {
        $.getJSON(`${layer.url}?request=GetLegendGraphic&service=WMS&version=1.1.1&format=application%2Fjson&layer=${layer.geoserverId}`).then((results) => {
            var legendText = ''
            try {
                const entries = results.Legend[0].rules[0].symbolizers[0].Raster.colormap.entries;
                entries.forEach(entry => {
                    let ignore = false;

                    if (entry.label === 'nodata') ignore = true;

                    if (!ignore) {
                        legendText += `
                        <div class="fwe-legendItem">
                            <div style="width: 16px; height: 16px; margin: 2px; background-color: ${entry.color}; border: solid 1px black"></div>
                            <small class="fwe-legendLabel"> ${entry.label} ${layer.units ? layer.units : ''} </small>
                        </div>
                    `
                    }
                });
                callback(legendText);
            } catch (err) {
                callback(`
                <p>Error: Unable to get the Legend</p>
             `)
            }

        })
    } 
    if (layer.lyrType === 'Observation') {
        $.getJSON(`${layer.url}?request=GetLegendGraphic&service=WMS&version=1.1.1&format=application%2Fjson&layer=${layer.geoserverId}`).then((results) => {
            var legendText = ''
            try {
                const entries = results.Legend[0].rules;
                entries.forEach((entry, idx) => {
                    console.log(`${entry.symbolizers[0].Point.graphics[0]["external-graphic-url"]}`)
                    let ignore = false;
                    if (entry.label === 'nodata') ignore = true;
                    if (!ignore) {
                        legendText += `
                        <div class="fwe-legendItem" style=" padding-bottom: 4px;">
                        <span style="float: left;">
                            <div style="width: 16px; height: 10px; margin: 2px; line-height: 24px" id="holder-${idx}" />
                        </span>
                            <small class="fwe-legendLabel"> ${entry.name} </small>
                        </div>
                    `
                    }

                    const url = entry.symbolizers[0].Point.graphics[0]["external-graphic-url"];
                    const geoserverStylesIndex = url.indexOf("geoserver/styles");
                    const geoserverPrefixUrl = GEOSERVER_URL.indexOf("/geoserver/");
                    if (geoserverStylesIndex !== -1 && geoserverPrefixUrl !== -1)  {
                        const geoserverPrefix = GEOSERVER_URL.substring(0, geoserverPrefixUrl)
                        const newUrl = `${geoserverPrefix}/${url.substring(geoserverStylesIndex)}`;
             makeGetRequest(newUrl)
                        .then(imageUrl => {
                            // Handle the image URL
                            displayImage(imageUrl);
                        })
                        .catch(error => {
                            // Handle any errors
                            console.error('Error:', error);
                        });

                        function displayImage(imageUrl) {
                        const divVal = document.getElementById(`holder-${idx}`);
                        const imageElement = document.createElement('img');
                        imageElement.src = imageUrl;

                        // Append the image element to a container or the document body
                        divVal.appendChild(imageElement);
                    }
                }
            });
                callback(legendText);
            } catch (err) {
                callback(`
                <p>Error: Unable to get the Legend</p>
             `)
            }
        
        })
    }
    
    else {
        $.getJSON(legendUrl).then(function(results) {

            var legendText = ''

            if (results.error || results.layers.length == 0) {
                callback(`
               <p>Error: Unable to get the Legend</p>
            `)
            } else {
                var legendLayer;
                for (var j = 0; j < results.layers.length; j++) {
                    legendLayer = results.layers[j]
                    if ((layer.legendLayerId && legendLayer.layerId == layer.legendLayerId) || (!layer.legendLayerId && legendLayer.layerName != "Boundary" && legendLayer.layerName != "Footprint")) {

                        var labelparts, legendLabel;
                        var legendElement, ignore;
                        var offset = 0;
                        for (var i = 0; i < legendLayer.legend.length; i++) {
                            legendElement = legendLayer.legend[i];
                            ignore = false;

                            if (!layer.legendLabels) {


                                labelparts = legendElement.label.split(' - ');
                                //labelparts[0] = Math.round(parseFloat(labelparts[0].replace(',', '')))

                                //if (!isNaN(labelparts[0])) {
                                //    legendLabel = labelparts[0]

                                //    if (labelparts.length > 1) {
                                //        labelparts[1] = Math.round(parseFloat(labelparts[1].replace(',', '')))
                                //        legendLabel += ' - ' + labelparts[1]
                                //    }
                                //} else {
                                // Legend must have been edited, and so just display it
                                if (legendElement.label.indexOf(';') > -1) {
                                    legendLabel = legendElement.label.split(';')[0].split(',')[0];
                                } else {
                                    legendLabel = legendElement.label;
                                }

                                //}

                            } else {
                                if (layer.legendLabels[i - offset]) {

                                    // Check to make sure the image from the last index isn't the same as
                                    // the current image. If so, then don't show it, and don't continue to the
                                    // next label index (by adding 1 to the offset)
                                    if (legendLayer.legend[i - 1]) {
                                        if (legendLayer.legend[i].imageData == legendLayer.legend[i - 1].imageData) {
                                            ignore = true
                                            offset++;
                                        }
                                    }

                                    legendLabel = layer.legendLabels[i - offset]
                                } else {
                                    ignore = true
                                }
                            }

                            if (!ignore) {
                                legendText += `
                                <div class="fwe-legendItem" style="margin-bottom: -8px;">
                                    <span style="float: left;">
                                        <img style="width: ${legendElement.width}px; height: ${legendElement.height}px;" src="data:${legendElement.contentType};base64,${legendElement.imageData}" alt="0 - 3" />
                                    </span>
                                    <small class="fwe-legendLabel"> ${legendLabel} ${layer.units ? layer.units : ''} </small>
                                </div>
                            `
                            }
                        }
                        break;
                    }
                }
                callback(legendText);

            }
        })
    }
}


export function getHimawariLayerId(layerName) {
    switch (layerName) {
        case 'Himawari True Colour':
            return 'IDE00435';
        case 'Himawari Visible Greyscale':
            return 'IDE00432';
        case 'Himawari Infrared Greyscale':
            return 'IDE00431';
        case 'Himawari Zehr False Colour':
            return 'IDE00433';
    }
}

export function initLayers(callback) {

    let currentTime = new Date();
    let currentTimePlus7Days = addHoursToDate(currentTime, 168);
    let currentTimePlus7Days1Hour = addHoursToDate(currentTime, 169);

    tx7Days = new TimeExtent();
    tx7Days.startTime = currentTime;
    tx7Days.endTime = currentTimePlus7Days;

    tx7Days1Hours = new TimeExtent();
    tx7Days1Hours.startTime = currentTime;
    tx7Days1Hours.endTime = currentTimePlus7Days1Hour;

    // const WindComposite_SFC_ISP = new ImageServiceParameters()

    var layersList = {
        'MaxT_SFC': {
            name: 'Daily Maximum Temperature',
            id: 'MaxT_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Daytime maximum temperature (<sup>o</sup>C) 6am to 9pm',
            shortDescription: 'Max <sup>o</sup>C',
            legend: 'legendMaxT',
            units: '<sup>o</sup>C',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71002_AUS_MaxT_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'MinT_SFC': {
            name: 'Daily Minimum Temperature',
            id: 'MinT_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Overnight minimum temperature (<sup>o</sup>C) to 9am',
            shortDescription: 'Min <sup>o</sup>C',
            legend: 'legendMinT',
            units: '<sup>o</sup>C',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71003_AUS_MinT_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'DailyPrecip10Pct_SFC': {
            name: 'Rainfall Total 10%',
            id: 'DailyPrecip10Pct_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [12],
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Rainfall total (mm) 10% chance of exceeding',
            shortDescription: 'Rain mm 10%',
            legend: 'legendDailyPrecip10',
            units: 'mm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71030_AUS_DailyPrecip10Pct_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'DailyPrecip25Pct_SFC': {
            name: 'Rainfall Total 25%',
            id: 'DailyPrecip25Pct_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [8],
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Rainfall total (mm) 25% chance of exceeding',
            shortDescription: 'Rain mm 25%',
            legend: 'legendDailyPrecip25',
            units: 'mm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71014_AUS_DailyPrecip25Pct_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'DailyPrecip50Pct_SFC': {
            name: 'Rainfall Total 50%',
            id: 'DailyPrecip50Pct_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Rainfall total (mm) 50% chance of exceeding',
            shortDescription: 'Rain mm 50%',
            legend: 'legendDailyPrecip50',
            units: 'mm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71015_AUS_DailyPrecip50Pct_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'DailyPrecip75Pct_SFC': {
            name: 'Rainfall Total 75%',
            id: 'DailyPrecip75Pct_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Rainfall total (mm) 75% chance of exceeding',
            shortDescription: 'Rain mm 75%',
            legend: 'legendDailyPrecip75',
            units: 'mm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71016_AUS_DailyPrecip75Pct_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'T_SFC': {
            name: 'Temperature',
            id: 'T_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Temperature ( <sup>o</sup>C)',
            shortDescription: '<sup>o</sup>C',
            legend: 'legendT',
            units: '<sup>o</sup>C',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71000_AUS_T_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'RH_SFC': {
            name: 'Relative Humidity',
            id: 'RH_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Relative humidity (%)',
            shortDescription: 'Humidity',
            legend: 'legendRH',
            units: '%',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71018_AUS_RH_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'RFS_PBFT_SFC': {
            name: 'Prescribed Burning',
            id: 'RFS_PBFT_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            qryCfg: { NSW: 2, VIC: 3 },
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Prescribed Burning Index',
            shortDescription: 'Prescribed Burning',
            legend: 'legendPBFT',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'RFS_PBFT_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'RFS_FuelAvailability_SFC': {
            name: 'Fuel Availability',
            id: 'RFS_FuelAvailability_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Fuel Availability Index',
            shortDescription: 'Fuel Availability',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'RFS_FuelAvailability_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'GrassCondition_SFC': {
            name: 'Grass Fuel Condition',
            id: 'GrassCondition_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Grass Fuel Condition',
            shortDescription: 'Grass Fuel Condition',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'ID071003_AUS_GrassCondition_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },

        'Td_SFC': {
            name: 'Dewpoint Temperature',
            id: 'Td_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [8],
            legendLayerId: 11,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Dew Point Temperature ( <sup>o</sup>C)',
            shortDescription: 'Dewpoint',
            legend: 'legendTd',
            units: '<sup>o</sup>C',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71001_AUS_Td_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },


        'SFWF': {
            name: 'SFWF',
            id: 'SFWF',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            schedule: 'Hourly',
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Special Fire Weather Forecasts',
            shortDescription: 'Special Fire Weather Forecasts',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: '	fireweather:incident_forecast',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },


        'FDR_SFC': {
            name: 'Fire Danger Rating',
            id: 'FDR_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Fire Danger Rating',
            shortDescription: 'FDR',
            legend: 'legendFDR',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10134_AUS_AFDRS_fdr_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'MaxFDR_SFC': {
            name: 'Daily Maximum FDR',
            id: 'MaxFDR_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Daytime maximum Fire Danger Rating',
            shortDescription: 'Max FDR',
            legend: 'legendMaxFDR',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10136_AUS_AFDRS_max_fdr_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'ROS_SFC': {
            name: 'Rate of Spread',
            id: 'ROS_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Hourly Rate of Spread',
            shortDescription: 'Rate of Spread',
            legend: 'legendROS',
            units: 'm/h',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10138_AUS_AFDRS_ros_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'FireIntensity_SFC': {
            name: 'Fire Intensity',
            id: 'FireIntensity_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Hourly Fire Intensity',
            shortDescription: 'Fire Intensity',
            legend: 'legendFireIntensity',
            units: 'kW/m',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10139_AUS_AFDRS_intensity_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'FH_SFC': {
            name: 'Flame Height',
            id: 'FH_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Hourly Flame Height',
            shortDescription: 'Flame Height',
            legend: 'legendFH',
            units: 'm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10141_AUS_AFDRS_flame_height_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'SD_SFC': {
            name: 'Spotting Distance',
            id: 'SD_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Hourly Spotting Distance',
            shortDescription: 'Spotting Distance',
            legend: 'legendSD',
            units: 'm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10142_AUS_AFDRS_spotting_distance_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'FBI_SFC': {
            name: 'Fire Behaviour Index',
            id: 'FBI_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Fire Behaviour Index',
            shortDescription: 'Fire Behaviour Index',
            legend: 'legendFBI',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10135_AUS_AFDRS_fbi_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'MaxFBI_SFC': {
            name: 'Daily Maximum Fire Behaviour Index',
            id: 'MaxFBI_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Daily Maximum Fire Behaviour Index',
            shortDescription: 'Max FDR',
            legend: 'legendMaxFBI',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10137_AUS_AFDRS_max_fbi_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },

        'KBDI_SFC': {
            name: 'Daily KBDI',
            id: 'KBDI_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Keetch Byram Drought Index',
            shortDescription: 'KBDI',
            legend: 'legendKBDI',
            units: 'mm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71147_AUS_KBDI_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'SDI_SFC': {
            name: 'SDI',
            id: 'SDI_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: "Mount's Soil Dryness Index",
            shortDescription: 'Soil Dryness Index',
            legend: 'legendSDI',
            units: 'mm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71235_AUS_SDI_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'SMI_SFC': {
            name: 'Soil Moisture Index',
            id: 'SMI_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: "Soil moisture fraction in the top 10 cm of the soil",
            shortDescription: 'Soil Moisture Index',
            legend: 'legendSMI',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10145_AUS_AFDRS_awap_upper_soil_moisture_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'CHaines_SFC': {
            name: 'Continuous Haines',
            id: 'CHaines_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Continuous Haines Index',
            shortDescription: 'C Haines',
            legend: 'legendCHaines',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71115_AUS_CHaines_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Curing_SFC': {
            name: 'Grass Curing',
            id: 'Curing_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Grass Curing',
            shortDescription: 'Curing',
            legend: 'LegendCuring',
            units: '%',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10148_AUS_FSE_curing_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'GrassFuelLoad_SFC': {
            name: 'Grass Fuel Load',
            id: 'GrassFuelLoad_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [8],
            legendLayerId: 11,
            schedule: 'Daily',
            timeExtent: tx7Days,
            dateFormat: 'dddd, MMMM dd, yyyy',
            shortDateFormat: 'ddd, MMM dd',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Grass Fuel Load',
            shortDescription: 'Grass',
            legend: 'LegendGrassFuelLoad',
            units: 't/ha',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ10159_AUS_FSE_grass_fuel_load_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'LAL2_SFC': {
            name: 'Lightning Activity Level',
            id: 'LAL2_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [8],
            legendLayerId: 11,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Lightning Activity Level',
            shortDescription: 'Lightning',
            legend: 'LegendLAL2',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71114_AUS_LAL2_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },

        'DF_SFC': {
            name: 'Drought Factor',
            id: 'DF_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Forest Fuel Dryness Factor',
            shortDescription: 'Drought Factor',
            legend: 'LegendDF',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71127_AUS_DF_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Wind_Dir_SFC': {
            name: '(Average) Wind Magnitude on Hour',
            id: 'Wind_Dir_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Wind magnitude (km/h) and direction',
            shortDescription: 'Wind surface',
            legend: 'LegendWindDir',
            units: 'km/h',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71089_AUS_Wind_Dir_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer'
            }
        },
        'WindMaxInHourMagKmh_SFC': {
            name: '(Average) Wind Max In Hour',
            id: 'WindMaxInHourMagKmh_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: '(Average) Wind Max In Hour (km/h)',
            shortDescription: 'Wind surface',
            legend: 'LegendWindDir',
            units: 'km/h',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            secondaryLayer: 'WindMagKmh_SFC',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71073_AUS_WindMaxInHourMagKmh_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer'
            }
        },
        'Wind_Dir_1500mAMSL': {
            name: 'Wind',
            id: 'Wind_Dir_1500mAMSL',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Wind magnitude (km/h) and direction',
            shortDescription: 'Wind surface',
            legend: 'LegendWindDir1500',
            units: 'km/h',
            legendLayerId: 7,
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            secondaryLayer: 'WindMagKmh_1500mAMSL',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71111_AUS_Wind_Dir_1500mAMSL',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'WindMagKmh_SFC': {
            name: 'Wind Magnitude',
            id: 'WindMagKmh_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            legendLayerId: 3,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Wind magnitude (km/h) and direction',
            shortDescription: 'Wind surface',
            legend: 'LegendWindMag',
            units: 'km/h',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71071_AUS_WindMagKmh_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'secondaryLayer'
            }
        },

        'WindMagKmh_1500mAMSL': {
            name: 'Wind Mag and Dir at 1500',
            id: 'WindMagKmh_1500mAMSL',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [4],
            legendLayerId: 7,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Wind magnitude (km/h) and direction',
            shortDescription: 'Wind 1500m',
            legend: 'legendWindMag1500',
            units: 'km/h',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71110_AUS_WindMagKmh_1500mAMSL',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'secondaryLayer',
            }
        },
        'MixHgt_SFC': {
            name: 'Mixing Height',
            id: 'MixHgt_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [8],
            legendLayerId: 11,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Mixing height',
            shortDescription: 'Mix height',
            legend: 'legendMixHgt',
            units: 'm',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71109_AUS_MixHgt_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Sky_SFC': {
            name: 'Cloud Cover',
            id: 'Sky_SFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [8],
            legendLayerId: 11,
            schedule: 'Hourly',
            timeExtent: tx7Days1Hours,
            dateFormat: 'ddd, dd MMMM yyyy hh:mm',
            shortDateFormat: 'ddd, MMM dd hh:mm',
            inputDateFormat: 'epoch',
            priority: 'High',
            description: 'Cloud Cover',
            shortDescription: 'Cloud Cover',
            legend: 'legendCloudCover',
            units: '',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'IDZ71017_AUS_Sky_SFC',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'WeatherStations': {
            name: 'Weather stations',
            id: 'WeatherStations',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Automated weather station',
            shortDescription: 'AWS',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Observation',
            geoserverId: 'weather_station',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'FireWeatherArea': {
            name: 'Fire Weather Area',
            id: 'FireWeatherArea',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Fire Weather Area',
            shortDescription: 'Fire Weather Area',
            legend: 'legendObs',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'fire_weather_area',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'fireWeatherAreaLayer',
            }
        },
        'FireManagementArea': {
            name: 'Fire Management Area',
            id: 'FireManagementArea',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Fire Management Area',
            shortDescription: 'Fire Management Area',
            legend: 'legendObs',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'fire_management_area',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'fireManagementAreaLayer',
            }
        },
        'Jurisdiction': {
            name: 'Jurisdiction',
            id: 'Jurisdiction',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Jurisdiction',
            shortDescription: 'Jurisdiction',
            legend: 'legendObs',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'Forecast_WMS',
            geoserverId: 'jurisdiction',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'jurisdictionLayer',
            }
        },
        'IncidentForecast': {
            name: 'Incident Weather Forecasts',
            id: 'IncidentForecast',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Incident Weather Forecasts',
            shortDescription: 'Incident Weather Forecasts',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'WMS',
            geoserverId: 'incident_forecast',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'SurfaceWind': {
            name: 'BoM AWS Surface Wind (knots, degN)',
            id: 'SurfaceWind',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'BoM AWS Surface Wind (knots, degN)',
            shortDescription: 'BoM AWS Surface Wind (knots, degN)',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDZ20010_wind',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'IDZ20010_wind',
            }
        },
        'Pressure': {
            name: 'Pressure (hPa)',
            id: 'Pressure',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Pressure (hPa)',
            shortDescription: 'Pressure (hPa)',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDZ20010_pres',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'IDZ20010_pres',
            }
        },
        'AirTemp': {
            name: 'Air Temp. (°C)',
            id: 'airTemp',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Air Temp. (°C)',
            shortDescription: 'Air Temp. (°C)',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDZ20010_air_temperature',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'IDZ20010_air_temperature',
            }
        },
        'RelativeHumidity': {
            name: 'Relative Humidity (%)',
            id: 'relativeHumidity',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Relative Humidity (%)',
            shortDescription: 'Relative Humidity (%)',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDZ20010_rel_humidity',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'IDZ20010_rel_humidity',
            }
        },
        'Rainfall9am': {
            name: 'Rain since 9am (mm)',
            id: 'rainfall9am',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            sublayers: [0],
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Rain since 9am (mm)',
            shortDescription: 'Rain since 9am (mm)',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            createTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDZ20010_rainfall_9am',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'IDZ20010_rainfall_9am',
            }
        },


        // 'CollectorObs1hr': {
        //     name: 'Collector Obs 1Hr',
        //     id: 'CollectorObs1hr',
        //     url: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_1hr/MapServer',
        //     qryUrl: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_1hr/MapServer/0',
        //     timeExtent: '',
        //     dateFormat: '',
        //     shortDateFormat: '',
        //     inputDateFormat: '',
        //     description: 'RFS Collector observations',
        //     shortDescription: 'Collector',
        //     legend: 'legendNone',
        //     startTime: '',
        //     fileTime: '',
        //     runTime: '',
        //     createTime: '',
        //     lyrType: 'Observation'
        // },
        // 'CollectorObs3hr': {
        //     name: 'Collector Obs 3Hr',
        //     id: 'CollectorObs3hr',
        //     url: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_3hr/MapServer',
        //     qryUrl: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_3hr/MapServer/0',
        //     timeExtent: '',
        //     dateFormat: '',
        //     shortDateFormat: '',
        //     inputDateFormat: '',
        //     description: 'RFS Collector observations',
        //     shortDescription: 'Collector',
        //     legend: 'legendNone',
        //     startTime: '',
        //     fileTime: '',
        //     runTime: '',
        //     createTime: '',
        //     lyrType: 'Observation'
        // },

        'BOM_Radar': {
            name: 'BOM Radar',
            id: 'BOM_Radar',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Weather Rain (Radar)',
            shortDescription: 'Bom Radar',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDR00010',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'BOM_Wind': {
            name: 'BOM Wind',
            id: 'BOM_Wind',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Weather Wind (Observation)',
            shortDescription: 'Bom Wind',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDZ20010_wind',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Himawari_TC': {
            name: 'Himawari True Colour',
            id: 'Himawari_TC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Himawari True Colour',
            shortDescription: 'HimawariTc',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDE00435',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Himawari_VG': {
            name: 'Himawari Visible Greyscale',
            id: 'Himawari_VG',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Himawari Visible Greyscale',
            shortDescription: 'HimawariVisGs',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDE00431',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Himawari_IG': {
            name: 'Himawari Infrared Greyscale',
            id: 'Himawari_IG',
            url: 'https://reg.bom.gov.au/cgi-bin/reg/ws/gis/users/bomw0107/wxs?',
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Himawari Infrared Greyscale',
            shortDescription: 'HimawariInfraGs',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDE00431',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        },
        'Himawari_ZFC': {
            name: 'Himawari Zehr False Colour',
            id: 'Himawari_ZFC',
            url: GEOSERVER_URL,
            qryUrl: GEOSERVER_URL,
            timeExtent: '',
            dateFormat: '',
            shortDateFormat: '',
            inputDateFormat: '',
            priority: 'High',
            description: 'Himawari Zehr False Colour',
            shortDescription: 'HimawariZehr',
            legend: 'legendNone',
            startTime: '',
            fileTime: '',
            runTime: '',
            lyrType: 'WMS',
            geoserverId: 'IDE00433',
            params: {
                format: "png",
                version: '1.1.0',
                id: 'weatherLayer',
            }
        }
    }

    layers = layersList;
    if (callback)
        callback(layersList);
}

export function OLD_initLayers(callback) {

    __non_webpack_require__([
        "esri/TimeExtent",
        "esri/layers/ImageServiceParameters",
    ], function(
        TimeExtent,
        ImageServiceParameters,
    ) {

        let currentTime = new Date();
        let currentTimePlus7Days = addHoursToDate(currentTime, 168);
        let currentTimePlus7Days1Hour = addHoursToDate(currentTime, 169);

        tx7Days = new TimeExtent();
        tx7Days.startTime = currentTime;
        tx7Days.endTime = currentTimePlus7Days;

        tx7Days1Hours = new TimeExtent();
        tx7Days1Hours.startTime = currentTime;
        tx7Days1Hours.endTime = currentTimePlus7Days1Hour;

        const WindComposite_SFC_ISP = new ImageServiceParameters()

        var layersList = {
            'MaxT_SFC': {
                name: 'Daily Maximum Temperature',
                id: 'MaxT_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Daytime maximum temperature (<sup>o</sup>C) 6am to 9pm',
                shortDescription: 'Max <sup>o</sup>C',
                legend: 'legendMaxT',
                units: '<sup>o</sup>C',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71002_AUS_MaxT_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'MinT_SFC': {
                name: 'Daily Minimum Temperature',
                id: 'MinT_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Overnight minimum temperature (<sup>o</sup>C) to 9am',
                shortDescription: 'Min <sup>o</sup>C',
                legend: 'legendMinT',
                units: '<sup>o</sup>C',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71003_AUS_MinT_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'DailyPrecip10Pct_SFC': {
                name: 'Rainfall Total 10%',
                id: 'DailyPrecip10Pct_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [12],
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Rainfall total (mm) 10% chance of exceeding',
                shortDescription: 'Rain mm 10%',
                legend: 'legendDailyPrecip10',
                units: 'mm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71030_AUS_DailyPrecip10Pct_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'DailyPrecip25Pct_SFC': {
                name: 'Rainfall Total 25%',
                id: 'DailyPrecip25Pct_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [8],
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Rainfall total (mm) 25% chance of exceeding',
                shortDescription: 'Rain mm 25%',
                legend: 'legendDailyPrecip25',
                units: 'mm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71014_AUS_DailyPrecip25Pct_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'DailyPrecip50Pct_SFC': {
                name: 'Rainfall Total 50%',
                id: 'DailyPrecip50Pct_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Rainfall total (mm) 50% chance of exceeding',
                shortDescription: 'Rain mm 50%',
                legend: 'legendDailyPrecip50',
                units: 'mm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71015_AUS_DailyPrecip50Pct_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'DailyPrecip75Pct_SFC': {
                name: 'Rainfall Total 75%',
                id: 'DailyPrecip75Pct_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Rainfall total (mm) 75% chance of exceeding',
                shortDescription: 'Rain mm 75%',
                legend: 'legendDailyPrecip75',
                units: 'mm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71016_AUS_DailyPrecip75Pct_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'T_SFC': {
                name: 'Temperature',
                id: 'T_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Temperature ( <sup>o</sup>C)',
                shortDescription: '<sup>o</sup>C',
                legend: 'legendT',
                units: '<sup>o</sup>C',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71000_AUS_T_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'RH_SFC': {
                name: 'Relative Humidity',
                id: 'RH_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Relative humidity (%)',
                shortDescription: 'Humidity',
                legend: 'legendRH',
                units: '%',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71018_AUS_RH_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'RFS_PBFT_SFC': {
                name: 'Prescribed Burning',
                id: 'RFS_PBFT_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                qryCfg: { NSW: 2, VIC: 3 },
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Prescribed Burning Index',
                shortDescription: 'Prescribed Burning',
                legend: 'legendPBFT',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'RFS_PBFT_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'RFS_FuelAvailability_SFC': {
                name: 'Fuel Availability',
                id: 'RFS_FuelAvailability_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Fuel Availability Index',
                shortDescription: 'Fuel Availability',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'RFS_FuelAvailability_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'GrassCondition_SFC': {
                name: 'Grass Fuel Condition',
                id: 'GrassCondition_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Grass Fuel Condition',
                shortDescription: 'Grass Fuel Condition',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'ID071003_AUS_GrassCondition_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },

            'Td_SFC': {
                name: 'Dewpoint Temperature',
                id: 'Td_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [8],
                legendLayerId: 11,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Dew Point Temperature ( <sup>o</sup>C)',
                shortDescription: 'Dewpoint',
                legend: 'legendTd',
                units: '<sup>o</sup>C',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71001_AUS_Td_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },


            'SFWF': {
                name: 'SFWF',
                id: 'SFWF',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                schedule: 'Hourly',
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Special Fire Weather Forecasts',
                shortDescription: 'Special Fire Weather Forecasts',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: '	fireweather:incident_forecast',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },


            'FDR_SFC': {
                name: 'Fire Danger Rating',
                id: 'FDR_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Fire Danger Rating',
                shortDescription: 'FDR',
                legend: 'legendFDR',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10134_AUS_AFDRS_fdr_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'MaxFDR_SFC': {
                name: 'Daily Maximum FDR',
                id: 'MaxFDR_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Daytime maximum Fire Danger Rating',
                shortDescription: 'Max FDR',
                legend: 'legendMaxFDR',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10136_AUS_AFDRS_max_fdr_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'ROS_SFC': {
                name: 'Rate of Spread',
                id: 'ROS_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Hourly Rate of Spread',
                shortDescription: 'Rate of Spread',
                legend: 'legendROS',
                units: 'm/h',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10138_AUS_AFDRS_ros_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'FireIntensity_SFC': {
                name: 'Fire Intensity',
                id: 'FireIntensity_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Hourly Fire Intensity',
                shortDescription: 'Fire Intensity',
                legend: 'legendFireIntensity',
                units: 'kW/m',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10139_AUS_AFDRS_intensity_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'FH_SFC': {
                name: 'Flame Height',
                id: 'FH_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Hourly Flame Height',
                shortDescription: 'Flame Height',
                legend: 'legendFH',
                units: 'm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10141_AUS_AFDRS_flame_height_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'SD_SFC': {
                name: 'Spotting Distance',
                id: 'SD_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Hourly Spotting Distance',
                shortDescription: 'Spotting Distance',
                legend: 'legendSD',
                units: 'm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10142_AUS_AFDRS_spotting_distance_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'FBI_SFC': {
                name: 'Fire Behaviour Index',
                id: 'FBI_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Fire Behaviour Index',
                shortDescription: 'Fire Behaviour Index',
                legend: 'legendFBI',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10135_AUS_AFDRS_fbi_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'MaxFBI_SFC': {
                name: 'Daily Maximum Fire Behaviour Index',
                id: 'MaxFBI_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Daily Maximum Fire Behaviour Index',
                shortDescription: 'Max FDR',
                legend: 'legendMaxFBI',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10137_AUS_AFDRS_max_fbi_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },

            'KBDI_SFC': {
                name: 'Daily KBDI',
                id: 'KBDI_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Keetch Byram Drought Index',
                shortDescription: 'KBDI',
                legend: 'legendKBDI',
                units: 'mm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71147_AUS_KBDI_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'SDI_SFC': {
                name: 'SDI',
                id: 'SDI_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: "Mount's Soil Dryness Index",
                shortDescription: 'Soil Dryness Index',
                legend: 'legendSDI',
                units: 'mm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71235_AUS_SDI_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'SMI_SFC': {
                name: 'Soil Moisture Index',
                id: 'SMI_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: "Soil moisture fraction in the top 10 cm of the soil",
                shortDescription: 'Soil Moisture Index',
                legend: 'legendSMI',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10145_AUS_AFDRS_awap_upper_soil_moisture_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'CHaines_SFC': {
                name: 'Continuous Haines',
                id: 'CHaines_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Continuous Haines Index',
                shortDescription: 'C Haines',
                legend: 'legendCHaines',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71115_AUS_CHaines_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Curing_SFC': {
                name: 'Grass Curing',
                id: 'Curing_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Grass Curing',
                shortDescription: 'Curing',
                legend: 'LegendCuring',
                units: '%',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10148_AUS_FSE_curing_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'GrassFuelLoad_SFC': {
                name: 'Grass Fuel Load',
                id: 'GrassFuelLoad_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [8],
                legendLayerId: 11,
                schedule: 'Daily',
                timeExtent: tx7Days,
                dateFormat: 'dddd, MMMM dd, yyyy',
                shortDateFormat: 'ddd, MMM dd',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Grass Fuel Load',
                shortDescription: 'Grass',
                legend: 'LegendGrassFuelLoad',
                units: 't/ha',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ10159_AUS_FSE_grass_fuel_load_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'LAL2_SFC': {
                name: 'Lightning Activity Level',
                id: 'LAL2_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [8],
                legendLayerId: 11,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Lightning Activity Level',
                shortDescription: 'Lightning',
                legend: 'LegendLAL2',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71114_AUS_LAL2_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Lightning': {
                name: 'Lightning',
                id: 'Lightning',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 0,
                schedule: 'Daily',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Lightning Strikes (latest 24 hours)',
                shortDescription: 'Lightning Strikes',
                legend: 'LegendLAL2',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDE00433',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                },
            },
            'DF_SFC': {
                name: 'Drought Factor',
                id: 'DF_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Forest Fuel Dryness Factor',
                shortDescription: 'Drought Factor',
                legend: 'LegendDF',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71127_AUS_DF_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Wind_Dir_SFC': {
                name: 'Wind',
                id: 'Wind_Dir_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Wind magnitude (km/h) and direction',
                shortDescription: 'Wind surface',
                legend: 'LegendWindDir',
                units: 'km/h',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                secondaryLayer: 'WindMagKmh_SFC',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71089_AUS_Wind_Dir_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer'
                }
            },
            'Wind_Dir_1500mAMSL': {
                name: 'Wind',
                id: 'Wind_Dir_1500mAMSL',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Wind magnitude (km/h) and direction',
                shortDescription: 'Wind surface',
                legend: 'LegendWindDir1500',
                units: 'km/h',
                legendLayerId: 7,
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                secondaryLayer: 'WindMagKmh_1500mAMSL',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71111_AUS_Wind_Dir_1500mAMSL',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'WindMagKmh_SFC': {
                name: 'Wind Magnitude',
                id: 'WindMagKmh_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                legendLayerId: 3,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Wind magnitude (km/h) and direction',
                shortDescription: 'Wind surface',
                legend: 'LegendWindMag',
                units: 'km/h',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71071_AUS_WindMagKmh_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'secondaryLayer'
                }
            },

            'WindMagKmh_1500mAMSL': {
                name: 'Wind Mag and Dir at 1500',
                id: 'WindMagKmh_1500mAMSL',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [4],
                legendLayerId: 7,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Wind magnitude (km/h) and direction',
                shortDescription: 'Wind 1500m',
                legend: 'legendWindMag1500',
                units: 'km/h',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71110_AUS_WindMagKmh_1500mAMSL',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'secondaryLayer',
                }
            },
            'MixHgt_SFC': {
                name: 'Mixing Height',
                id: 'MixHgt_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [8],
                legendLayerId: 11,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Mixing height',
                shortDescription: 'Mix height',
                legend: 'legendMixHgt',
                units: 'm',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71109_AUS_MixHgt_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Sky_SFC': {
                name: 'Cloud Cover',
                id: 'Sky_SFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [8],
                legendLayerId: 11,
                schedule: 'Hourly',
                timeExtent: tx7Days1Hours,
                dateFormat: 'ddd, dd MMMM yyyy hh:mm',
                shortDateFormat: 'ddd, MMM dd hh:mm',
                inputDateFormat: 'epoch',
                priority: 'High',
                description: 'Cloud Cover',
                shortDescription: 'Cloud Cover',
                legend: 'legendCloudCover',
                units: '',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'IDZ71017_AUS_Sky_SFC',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'WeatherStations': {
                name: 'Weather stations',
                id: 'WeatherStations',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Automated weather station',
                shortDescription: 'AWS',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Observation',
                geoserverId: 'weather_station',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'FireWeatherArea': {
                name: 'Fire Weather Area',
                id: 'FireWeatherArea',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Fire Weather Area',
                shortDescription: 'Fire Weather Area',
                legend: 'legendObs',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'fire_weather_area',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'fireWeatherAreaLayer',
                }
            },
            'FireManagementArea': {
                name: 'Fire Management Area',
                id: 'FireManagementArea',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Fire Management Area',
                shortDescription: 'Fire Management Area',
                legend: 'legendObs',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'fire_management_area',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'fireManagementAreaLayer',
                }
            },
            'Jurisdiction': {
                name: 'Jurisdiction',
                id: 'Jurisdiction',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Jurisdiction',
                shortDescription: 'Jurisdiction',
                legend: 'legendObs',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'Forecast_WMS',
                geoserverId: 'jurisdiction',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'jurisdictionLayer',
                }
            },
            'IncidentForecast': {
                name: 'Incident Weather Forecasts',
                id: 'IncidentForecast',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Incident Weather Forecasts',
                shortDescription: 'Incident Weather Forecasts',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'WMS',
                geoserverId: 'incident_forecast',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'SurfaceWind': {
                name: 'BoM AWS Surface Wind (knots, degN)',
                id: 'SurfaceWind',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'BoM AWS Surface Wind (knots, degN)',
                shortDescription: 'BoM AWS Surface Wind (knots, degN)',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDZ20010_wind',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'IDZ20010_wind',
                }
            },
            'Pressure': {
                name: 'Pressure (hPa)',
                id: 'Pressure',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Pressure (hPa)',
                shortDescription: 'Pressure (hPa)',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDZ20010_pres',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'IDZ20010_pres',
                }
            },
            'AirTemp': {
                name: 'Air Temp. (°C)',
                id: 'airTemp',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Air Temp. (°C)',
                shortDescription: 'Air Temp. (°C)',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDZ20010_air_temperature',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'IDZ20010_air_temperature',
                }
            },
            'RelativeHumidity': {
                name: 'Relative Humidity (%)',
                id: 'relativeHumidity',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Relative Humidity (%)',
                shortDescription: 'Relative Humidity (%)',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDZ20010_rel_humidity',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'IDZ20010_rel_humidity',
                }
            },
            'Rainfall9am': {
                name: 'Rain since 9am (mm)',
                id: 'rainfall9am',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                sublayers: [0],
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Rain since 9am (mm)',
                shortDescription: 'Rain since 9am (mm)',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                createTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDZ20010_rainfall_9am',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'IDZ20010_rainfall_9am',
                }
            },


            // 'CollectorObs1hr': {
            //     name: 'Collector Obs 1Hr',
            //     id: 'CollectorObs1hr',
            //     url: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_1hr/MapServer',
            //     qryUrl: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_1hr/MapServer/0',
            //     timeExtent: '',
            //     dateFormat: '',
            //     shortDateFormat: '',
            //     inputDateFormat: '',
            //     description: 'RFS Collector observations',
            //     shortDescription: 'Collector',
            //     legend: 'legendNone',
            //     startTime: '',
            //     fileTime: '',
            //     runTime: '',
            //     createTime: '',
            //     lyrType: 'Observation'
            // },
            // 'CollectorObs3hr': {
            //     name: 'Collector Obs 3Hr',
            //     id: 'CollectorObs3hr',
            //     url: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_3hr/MapServer',
            //     qryUrl: 'https://collector.rfs.nsw.gov.au/arcgisserver/rest/services/FieldObs/PROD_WeatherObPresentation_3hr/MapServer/0',
            //     timeExtent: '',
            //     dateFormat: '',
            //     shortDateFormat: '',
            //     inputDateFormat: '',
            //     description: 'RFS Collector observations',
            //     shortDescription: 'Collector',
            //     legend: 'legendNone',
            //     startTime: '',
            //     fileTime: '',
            //     runTime: '',
            //     createTime: '',
            //     lyrType: 'Observation'
            // },

            'BOM_Radar': {
                name: 'BOM Radar',
                id: 'BOM_Radar',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Weather Rain (Radar)',
                shortDescription: 'Bom Radar',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDR00010',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'BOM_Wind': {
                name: 'BOM Wind',
                id: 'BOM_Wind',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Weather Wind (Observation)',
                shortDescription: 'Bom Wind',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDZ20010_wind',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Himawari_TC': {
                name: 'Himawari True Colour',
                id: 'Himawari_TC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Himawari True Colour',
                shortDescription: 'HimawariTc',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDE00435',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Himawari_VG': {
                name: 'Himawari Visible Greyscale',
                id: 'Himawari_VG',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Himawari Visible Greyscale',
                shortDescription: 'HimawariVisGs',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDE00431',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Himawari_IG': {
                name: 'Himawari Infrared Greyscale',
                id: 'Himawari_IG',
                url: GEOSERVER_URL,
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Himawari Infrared Greyscale',
                shortDescription: 'HimawariInfraGs',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDE00431',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            },
            'Himawari_ZFC': {
                name: 'Himawari Zehr False Colour',
                id: 'Himawari_ZFC',
                url: GEOSERVER_URL,
                qryUrl: GEOSERVER_URL,
                timeExtent: '',
                dateFormat: '',
                shortDateFormat: '',
                inputDateFormat: '',
                priority: 'High',
                description: 'Himawari Zehr False Colour',
                shortDescription: 'HimawariZehr',
                legend: 'legendNone',
                startTime: '',
                fileTime: '',
                runTime: '',
                lyrType: 'WMS',
                geoserverId: 'IDE00433',
                params: {
                    format: "png",
                    version: '1.1.0',
                    id: 'weatherLayer',
                }
            }
        }

        layers = layersList;
        if (callback)
            callback(layersList);
    });
}